import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m11.42 15.176 5.83 5.83a2.652 2.652 0 1 0 3.75-3.75l-5.877-5.876m-3.704 3.796 2.496-3.03c.317-.385.74-.626 1.208-.766m-3.704 3.796L6.764 20.83a2.548 2.548 0 1 1-3.586-3.587l6.837-5.63m5.108-.232c.55-.164 1.163-.188 1.743-.14q.19.017.384.017a4.5 4.5 0 0 0 4.102-6.352L18.076 8.18a3 3 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.075-.071 2.264-.904 2.95l-.102.084m-1.745 1.437L5.909 7.507H4.5l-2.25-3.75 1.5-1.5 3.75 2.25v1.409l4.26 4.26m-1.745 1.436 1.745-1.437m6.615 8.207-2.625-2.625M4.867 19.132h.008v.007h-.008z"
    }, null, -1)
  ])))
}
export default { render: render }